<template>
  <div class="big">
    <div class="page_title flex_between">
      <span>商品订单详情</span>
      <el-button type="primary" style="width: 92px" size="medium" @click="back"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <!-- 物流详情弹窗 -->
        <el-dialog
          title="查看物流"
          :visible.sync="express"
          width="800px"
          style="text-align: left"
          :close-on-click-modal="false"
        >
          <div style="padding-bottom: 20px">
            <div
              style="
                padding: 20px 20px 20px 40px;
                height: 600px;
                overflow: auto;
              "
            >
              <div>
                <span style="color: #666">快递公司：</span>
                <span>{{ express_data.express_name }}</span>
              </div>
              <div style="margin: 10px 0">
                <span style="color: #666">运单号：</span>
                <span>{{ express_data.express_no }}</span>
              </div>
              <div style="margin-bottom: 30px">
                <span style="color: #666">联系电话：</span>
                <span>{{ express_data.express_phone }}</span>
              </div>

              <el-timeline>
                <el-timeline-item
                  v-for="(item, index) in express_data.logistics_list"
                  :key="index"
                  :icon="item.icon"
                  :type="item.type"
                  :color="item.color"
                  :size="item.size"
                  :timestamp="item.time"
                  >{{ item.context }}</el-timeline-item
                >
              </el-timeline>
            </div>
            <div style="text-align: right; padding-right: 20px">
              <el-button
                type="primary"
                @click="express = false"
                style="width: 92px"
                >确定</el-button
              >
            </div>
          </div>
        </el-dialog>

        <div class="content">
          <el-steps
            :active="active"
            process-status="wait"
            v-if="
              detail.status != 5 && detail.status != 6 && detail.status != 7
            "
          >
            <el-step
              title="提交订单"
              :description="detail.create_time"
            ></el-step>
            <el-step title="支付订单" :description="detail.pay_time"></el-step>
            <el-step title="商家发货" :description="detail.send_time"></el-step>
            <el-step title="客户收货"></el-step>
            <el-step
              title="订单完成"
              :description="detail.completion_time"
            ></el-step>
          </el-steps>
          <div class="statusbox flex align-center">
            <div class="flex align-center">
              当前订单状态：
              <span style="color: #669961; font-weight: 600">{{
                detail.status | filterStatus
              }}</span>

              <span
                style="margin-left: 20px"
                v-if="
                  detail.status == 5 || detail.status == 6 || detail.status == 7
                "
              >
                售后状态：{{ detail.refund_status == 0 ? '未退款' : '已退款' }}
                <template v-if="detail.refund_time"
                  >退款时间：{{ detail.refund_time }}</template
                >
              </span>
            </div>

            <div>
              <el-button
                type="primary"
                style="width: 120px"
                v-if="
                  (detail.status == 3 || detail.status == 4) &&
                  detail.delivery == 1
                "
                @click="orderExpress"
                >查看物流</el-button
              >
            </div>
          </div>
        </div>
        <div style="width: 100%; height: 1px; background: #d7d7d7"></div>
        <div class="content">
          <div>
            <div class="title">基本信息</div>
            <div class="infobox">
              <div style="display: flex">
                <div style="width: 260px">
                  <span class="little_title">订单编号</span>
                  <span>{{ detail.order_sn }}</span>
                </div>
                <div style="width: 260px">
                  <span class="little_title">提交时间</span>
                  <span>{{ detail.create_time }}</span>
                </div>
              </div>
              <div style="display: flex; margin: 30px 0 20px">
                <div style="width: 260px">
                  <span class="little_title">用户姓名</span>
                  <span>{{ detail.real_name }}</span>
                </div>
                <div style="width: 260px">
                  <span class="little_title">用户手机号</span>
                  <span>{{ detail.phone }}</span>
                </div>
              </div>
            </div>
          </div>
          <div
            style="
              width: 100%;
              height: 2px;
              background: #ececec;
              margin-bottom: 12px;
            "
          ></div>
          <div>
            <div class="title">收货信息</div>
            <div class="infobox">
              <div style="display: flex; margin-bottom: 30px">
                <div
                  style="width: 260px"
                  v-if="detail.address_info.consignee_name"
                >
                  <span class="little_title">收货人</span>
                  <span>{{ detail.address_info.consignee_name }}</span>
                </div>
                <div
                  style="width: 260px"
                  v-if="detail.address_info.consignee_phone"
                >
                  <span class="little_title">联系电话</span>
                  <span>{{ detail.address_info.consignee_phone }}</span>
                </div>
                <div>
                  <span class="little_title">收货地址</span>
                  <span style="color: #666"
                    >{{ detail.address_info.province_name
                    }}{{ detail.address_info.city_name
                    }}{{ detail.address_info.district_name
                    }}{{ detail.address_info.address }}</span
                  >
                </div>
              </div>
              <div style="margin-bottom: 20px" class="flex">
                <div style="width: 260px">
                  <span class="little_title">配送方式</span>
                  <span>{{ detail.delivery == 1 ? '快递' : '自提' }}</span>
                </div>
                <div style="width: 260px" v-if="detail.user_express_name">
                  <span class="little_title">快递公司</span>
                  <span>{{ detail.user_express_name }}</span>
                </div>
                <div style="width: 260px" v-if="detail.express_name">
                  <span class="little_title">快递公司（实际发货）</span>
                  <span>{{ detail.express_name }}</span>
                </div>
                <div style="width: 260px" v-if="detail.express_no">
                  <span class="little_title">快递单号</span>
                  <span>{{ detail.express_no }}</span>
                </div>
              </div>
            </div>
          </div>

          <div
            style="
              width: 100%;
              height: 2px;
              background: #ececec;
              margin-bottom: 12px;
            "
          ></div>
          <div class="title">商品信息</div>
          <el-table
            ref="multipleTable"
            :data="detail.item_list"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column label="商品" width="300">
              <template slot-scope="scope">
                <div class="flex align-center">
                  <img
                    :src="scope.row.picture"
                    alt
                    style="width: auto; height: 76px; margin-right: 5px"
                  />
                  <p>{{ scope.row.goods_name }}</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="规格" prop="sku_name"></el-table-column>
            <el-table-column
              label="商品编码"
              prop="goods_code"
            ></el-table-column>
            <el-table-column label="价格" prop="price"></el-table-column>
            <el-table-column label="购买数量" prop="num"></el-table-column>
          </el-table>
          <div
            v-for="(item, index) in detail.price_list"
            :key="index"
            class="price"
          >
            {{ item.name }}:{{ item.price }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
export default {
  data() {
    return {
      order_id: this.$route.query.order_id,
      dialog: false,
      express: false,
      detail: {
        status: 1,
        address_info: {}
      },
      company_list: [],
      express_data: {},
      co_id: '',
      express_no: '',
      addressShow: false
    };
  },
  filters: {
    filterStatus(val) {
      switch (val) {
        case 1:
          return '待付款';
        case 2:
          return '待发货';
        case 3:
          return '待收货';
        case 4:
          return '已完成';
        case 5:
          return '已取消[超时未支付]';
        case 6:
          return '已取消[用户取消]';
        case 7:
          return '已取消[超时未发货]';
        case 8:
          return '用户申请退款';
      }
    }
  },
  computed: {
    active() {
      switch (this.detail.status) {
        case 1:
          return 2;
        case 2:
          return 3;
        case 3:
          return 4;
        case 4:
          return 5;
      }
    }
  },
  methods: {
    //获取详情
    getDetail() {
      this.axios
        .post('platform/shop/getUserOrderInfo', { order_id: this.order_id })
        .then((res) => {
          if (res.code == 0) {
            let info = res.data.info;
            if (info.create_time) {
              info.create_time = dayjs(info.create_time * 1000).format(
                'YYYY-MM-DD HH:mm:ss'
              );
            }
            if (info.pay_time) {
              info.pay_time = dayjs(info.pay_time * 1000).format(
                'YYYY-MM-DD HH:mm:ss'
              );
            }
            if (info.send_time) {
              info.send_time = dayjs(info.send_time * 1000).format(
                'YYYY-MM-DD HH:mm:ss'
              );
            }
            if (info.completion_time) {
              info.completion_time = dayjs(info.completion_time * 1000).format(
                'YYYY-MM-DD HH:mm:ss'
              );
            }
            info.item_list.forEach((ele) => {
              ele.create_time = dayjs(ele.create_time * 1000).format(
                'YYYY-MM-DD HH:mm:ss'
              );
            });
            this.detail = info;
          }
        });
    },

    //查看物流信息
    orderExpress() {
      this.axios
        .post('/platform/shop/getOrderLogisticsInfo', {
          order_id: this.order_id
        })
        .then((res) => {
          this.express_data = res.data.info;
          console.log(this.express_data);
          this.express_data.logistics_list[0].type = 'primary';
          this.express_data.logistics_list[0].size = 'large';
          setTimeout(() => {
            this.express = true;
          }, 500);
        })
        .catch((err) => {});
    },
    back() {
      history.back();
    }
  },
  created() {
    this.getDetail();
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.el-step {
  margin-bottom: 15px;
}
.content {
  padding: 24px;
  box-sizing: border-box;
  text-align: left;
}
.steptext {
  display: flex;
  padding: 10px 30px;
  text-align: left;
}
.statusbox {
  width: 100%;
  text-align: left;
  background-color: #e9f4df;
  border-radius: 6px;
  border: solid 1px #d6eac4;
  padding: 10px 24px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 24px;
}
.little_title {
  color: #333;
  font-weight: 600;
  margin-right: 10px;
}

.infobox {
  text-align: left;
}
.dialogbox {
  padding: 40px 0;
  text-align: center;
}
.price {
  text-align: right;
  line-height: 25px;
}
.top {
  color: #262626;
  font-weight: bold;
  margin-bottom: 10px;
}
.info {
  margin-bottom: 10px;
  div + div {
    margin-left: 30px;
  }
  .label {
    color: #262626;
    margin-right: 10px;
  }
  .text {
    color: #666666;
  }
}
.tips {
  p {
    color: #fc8740;
    line-height: 25px;
  }
}
.newAddress {
  background-color: aliceblue;
  padding: 15px;
  margin-top: 10px;
}
</style>
<style lang="scss">
.mystep_bar .el-step__head {
  width: 170px;
}
.mystep_bar .el-step.is-center .el-step__head {
  text-align: left;
}
</style>
